import { IPhoneCenterSearchForm } from "src/pages/Configuration/PhoneCenters/PhoneCenters/phoneCenter";

const unitSearchFormKeys: (keyof IUnitSearchForm)[] = [
  'description',
  'sapCode',
  'unID',
  'deleted',
  'placeID'
];

const establishmentSearchFormKeys: (keyof IEstablishmentSearchForm)[] = [
  'description',
  'sapCode',
  'unID',
  'deleted',
  'placeID'
];

const departmentSearchFormKeys: (keyof IDepartmentSearchForm)[] = [
  'description',
  'sapCode',
  'unID',
  'deleted',
  'placeID'
];

const dCompanySearchFormKeys: (keyof IDCompanySearchForm)[] = [
  'description',
  'sapCode',
  'unID',
  'deleted',
  'placeID'
];

const atmSearchFormKeys: (keyof IAtmSearchForm)[] = [
  'description',
  //'sapCode',
  'unID',
  'deleted',
  'atmTerm',
  'lineType',
  'comments'
];

const phoneLineSearchFormKeys: (keyof IPhoneLineSearchForm)[] = [
  'pendingStatusID',
  'phoneNumber',
  'providerID',
  'sapCode',
  'deleted',
  'unitID',
  'unitType',
  'removalDateFrom',
  'removalDateTo',
  'comments',
  'descline'
];

const phoneCentersSearchFormKeys: (keyof IPhoneCenterSearchForm)[] = [
  'description', 
];

const nodeSearchFormKeys: (keyof INodeSearchForm)[] = [
  'description', 
];

const dataLineSearchFormKeys: (keyof IDataLineSearchForm)[] = [
  'descline', 
  'hcNmsNum', 
  'lineTypeID', 
  'pendingStatusID', 
  'phoneNumber', 
  'providerID', 
  'sapCode', 
  'speedID',
  'deleted',
  'removalDateFrom',
  'removalDateTo',
  'comments'
];

const billingSearchFormKeys: (keyof IBillingSummarySearchForm)[] = [
  'year',
  'monthName',
  'providerID'
]

const userInspectorSearchFormKeys: (keyof IUserInspectorSearchForm)[] = [
  'datetimeFrom',
  'datetimeTo',
  'username'
];

const hasKey = (obj: object, key: string): boolean => {
  return key in obj;
}

const isSearchFormOfType = <T extends IFilterType>(filterObj: IFilterType, keys: (keyof T)[]): filterObj is T => {
  return typeof filterObj === 'object' && keys.every(key => hasKey(filterObj, key as string)) && Object.keys(filterObj).length === keys.length;
}

const isSearchFormEmpty = <T extends IFilterType>(searchFormData: T | undefined, keys: (keyof T)[]): boolean => {
  if (searchFormData == undefined) { return true; }
  return keys.every(key => searchFormData[key] === "");
}

export const isTypeOfUnitSearchForm = (filterObj: IFilterType): filterObj is IUnitSearchForm => {
  return isSearchFormOfType<IUnitSearchForm>(filterObj, unitSearchFormKeys);
}

export const isUnitSearchFormEmpty = (filterObj: IFilterType): filterObj is IUnitSearchForm => {
  return isSearchFormEmpty<IUnitSearchForm>(filterObj, unitSearchFormKeys);
}

export const isTypeOfEstablishmentSearchForm = (filterObj: IFilterType): filterObj is IEstablishmentSearchForm => {
  return isSearchFormOfType<IEstablishmentSearchForm>(filterObj, establishmentSearchFormKeys);
}

export const isEstablishmentSearchFormEmpty = (filterObj: IFilterType): filterObj is IEstablishmentSearchForm => {
  return isSearchFormEmpty<IEstablishmentSearchForm>(filterObj, establishmentSearchFormKeys);
}

export const isTypeOfDepartmentSearchForm = (filterObj: IFilterType): filterObj is IDepartmentSearchForm => {
  return isSearchFormOfType<IDepartmentSearchForm>(filterObj, departmentSearchFormKeys);
}

export const isDepartmentSearchFormEmpty = (filterObj: IFilterType): filterObj is IDepartmentSearchForm => {
  return isSearchFormEmpty<IDepartmentSearchForm>(filterObj, departmentSearchFormKeys);
}

export const isTypeOfDCompanySearchForm = (filterObj: IFilterType): filterObj is IDCompanySearchForm => {
  return isSearchFormOfType<IDCompanySearchForm>(filterObj, dCompanySearchFormKeys);
}

export const isDCompanySearchFormEmpty = (filterObj: IFilterType): filterObj is IDCompanySearchForm => {
  return isSearchFormEmpty<IDCompanySearchForm>(filterObj, dCompanySearchFormKeys);
}

export const isTypeOfAtmSearchForm = (filterObj: IFilterType): filterObj is IAtmSearchForm => {
  return isSearchFormOfType<IAtmSearchForm>(filterObj, atmSearchFormKeys);
}

export const isAtmSearchFormEmpty = (filterObj: IFilterType): filterObj is IAtmSearchForm => {
  return isSearchFormEmpty<IAtmSearchForm>(filterObj, atmSearchFormKeys);
}

export const isTypeOfPhoneLineSearchForm = (filterObj: IFilterType): filterObj is IPhoneLineSearchForm => {
  return isSearchFormOfType<IPhoneLineSearchForm>(filterObj, phoneLineSearchFormKeys);
}

export const isPhoneLineSearchFormEmpty = (filterObj: IFilterType): filterObj is IPhoneLineSearchForm => {
  return isSearchFormEmpty<IPhoneLineSearchForm>(filterObj, phoneLineSearchFormKeys);
}

export const isTypeOfPhoneCenterSearchForm = (filterObj: IFilterType): filterObj is IPhoneCenterSearchForm => {
  return isSearchFormOfType<IPhoneCenterSearchForm>(filterObj, phoneCentersSearchFormKeys);
}

export const isPhoneCenterSearchFormEmpty = (filterObj: IFilterType): filterObj is IPhoneCenterSearchForm => {
  return isSearchFormEmpty<IPhoneCenterSearchForm>(filterObj, phoneCentersSearchFormKeys);
}

export const isTypeOfNodeSearchForm = (filterObj: IFilterType): filterObj is INodeSearchForm => {
  return isSearchFormOfType<INodeSearchForm>(filterObj, nodeSearchFormKeys);
}

export const isNodeSearchFormEmpty = (searchFormData: INodeSearchForm | undefined): boolean => {
  return isSearchFormEmpty<INodeSearchForm>(searchFormData, nodeSearchFormKeys);
}

export const isTypeOfDataLineSearchForm = (filterObj: IFilterType): filterObj is IDataLineSearchForm => {
  return isSearchFormOfType<IDataLineSearchForm>(filterObj, dataLineSearchFormKeys);
}

export const isDataLineSearchFormEmpty = (searchFormData: IDataLineSearchForm | undefined): boolean => {
  return isSearchFormEmpty<IDataLineSearchForm>(searchFormData, dataLineSearchFormKeys);
}

export const isTypeOfBillingSearchForm = (filterObj: IFilterType): filterObj is IBillingSummarySearchForm => {
  return isSearchFormOfType<IBillingSummarySearchForm>(filterObj, billingSearchFormKeys);
}

export const isBillingSearchFormEmpty = (filterObj: IFilterType): filterObj is IBillingSummarySearchForm => {
  return isSearchFormEmpty<IBillingSummarySearchForm>(filterObj, billingSearchFormKeys);
}

export const isTypeOfUserInspectorSearchForm = (filterObj: IFilterType): filterObj is IUserInspectorSearchForm => {
  return isSearchFormOfType<IUserInspectorSearchForm>(filterObj, userInspectorSearchFormKeys);
}

export const isUserInspectorSearchFormEmpty = (filterObj: IFilterType): filterObj is IUserInspectorSearchForm => {
  return isSearchFormEmpty<IUserInspectorSearchForm>(filterObj, userInspectorSearchFormKeys);
}